"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var WEB_SOCKET_EVENTS;
(function (WEB_SOCKET_EVENTS) {
    WEB_SOCKET_EVENTS["OPEN"] = "open";
    WEB_SOCKET_EVENTS["MESSAGE"] = "message";
    WEB_SOCKET_EVENTS["ERROR"] = "error";
    WEB_SOCKET_EVENTS["CLOSE"] = "close";
})(WEB_SOCKET_EVENTS = exports.WEB_SOCKET_EVENTS || (exports.WEB_SOCKET_EVENTS = {}));
exports.OPEN_SOCKET_TIMEOUT = 10000;
exports.REOPEN_TIMEOUT = 30000;
var ERROR_MESSAGES;
(function (ERROR_MESSAGES) {
    ERROR_MESSAGES["GET_TOKEN_FAILED"] = "Unable to get token";
    ERROR_MESSAGES["TIMEOUT"] = "Unable to open socket during 10s";
    ERROR_MESSAGES["INVALID_JSON"] = "Invalid json received";
    ERROR_MESSAGES["ERROR"] = "Error occured in socket";
})(ERROR_MESSAGES = exports.ERROR_MESSAGES || (exports.ERROR_MESSAGES = {}));
var supportedEventNames = utils_1.getObjectValues(WEB_SOCKET_EVENTS).join(', ');
exports.INVALID_EVENT_NAME_MESSAGE = "avaiable events are: " + supportedEventNames;
var MESSAGES;
(function (MESSAGES) {
    MESSAGES["SOCKET_OPENED"] = "Socket opened";
    MESSAGES["SOCKET_CLOSED"] = "Socket closed";
    MESSAGES["MESSAGE_RECEIVED"] = "Message received";
    MESSAGES["REOPENING"] = "Connection closed, reopening";
})(MESSAGES = exports.MESSAGES || (exports.MESSAGES = {}));
//# sourceMappingURL=constants.js.map